import { CategoryScale, Chart as ChartJS, Legend, LinearScale, LineElement, PointElement, Title, Tooltip } from 'chart.js';
import _ from "lodash";
import React, { useEffect, useRef } from "react";
import { Line } from 'react-chartjs-2';

ChartJS.register(
   CategoryScale,
   LinearScale,
   PointElement,
   LineElement,
   Title,
   Tooltip,
   Legend
);

export const options = {
   responsive: true,
   plugins: {
      legend: {
         position: 'top',
      },
      title: {
         display: true,
         text: 'Chart.js Line Chart',
      },
   },
};

const dataSectionsBackgroundColors = (colorArrayReq) => {
   let origColors = [
      "rgba(43,114,185,255)",
      "rgba(161,208,255,255)",
      "rgba(248,144,80,255)",
      "rgba(247,111,30,255)",
      "rgba(242,242,242,255)",
   ];
   return _.map(colorArrayReq, (q, idx) => {
      return idx < 4 ? origColors[idx] : origColors[idx % 4];
   });
};

function shapeData(data) {
   return {
      labels: _.map(data, c => { return c.label }),
      datasets: [
         {
            data: _.map(data, c => { return c.value }),
            backgroundColor: dataSectionsBackgroundColors(data),
            borderColor: dataSectionsBackgroundColors(data),
            borderWidth: 1,
            datalabels: {
               anchor: 'middle'
            }
         },
      ],
   };
}

function shapeOptions(props) {
   const { usePercentSign } = props;
   return {
      aspectRatio: 1,
      responsive: true,
      maintainAspectRatio: true,
      plugins: {
         legend: {
            display: false,
         },
         datalabels: {
            backgroundColor: function (context) {
               var dataset = context.dataset;
               var value = dataset.data[context.dataIndex];
               if (value < 100) {
                  return 'rgba(247,111,30,255)'
               } else {
                  return 'rgba(43,114,185,255)'
               }
            },
            color: 'white',
            display: function (context) {
               var dataset = context.dataset;
               var count = dataset.data.length;
               var value = dataset.data[context.dataIndex];
               return value > count * 1.5;
            },
            font: {
               weight: 'bold'
            },
            borderRadius: '3',
            padding: 6,
            formatter: function (value, context) {
               value = value.toFixed(1);
               if (usePercentSign) {
                  value = value + '%';
               }
               return value;
            }
         },
      },
      legend: {
         display: false,
      },
      layout: {
         padding: {
            right: 25,
            top: 25,
         }
      }
   }
}

// This component is only used on the On Time Delivery Report which was moved to Power BI
export function LineChart(props) {
   const chartRef = useRef();
   //let parentNode;  // Should this have a setter ??

   useEffect(() => {
      //parentNode = chartRef.current?.parentNode;
   }, [chartRef]);

   if (props && props.data) {
      const data = shapeData(props.data);
      const options = shapeOptions(props);
      return <div className={"chart-container p-3"} ref={chartRef}>
         <Line data={data} options={options} />
      </div>;
   } else {
      console.error("Line chart requires 'data' as a prop")
   }
   return null;
}
